import React from 'react';

const logos = {
  openai: ({ size, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="none" />
      <text x="12" y="16" textAnchor="middle" fill="#10b981" fontSize="12" fontWeight="600" fontFamily="Inter, sans-serif">O</text>
    </svg>
  ),
  anthropic: ({ size, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 3L22 20H2L12 3Z" stroke="#f97316" strokeWidth="2" fill="none" />
      <text x="12" y="18" textAnchor="middle" fill="#f97316" fontSize="9" fontWeight="600" fontFamily="Inter, sans-serif">A</text>
    </svg>
  ),
  deepseek: ({ size, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="2" y="4" width="20" height="16" rx="3" stroke="#8b5cf6" strokeWidth="2" fill="none" />
      <text x="12" y="16" textAnchor="middle" fill="#8b5cf6" fontSize="9" fontWeight="600" fontFamily="JetBrains Mono, monospace">DS</text>
    </svg>
  ),
  google: ({ size, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="10" stroke="#3b82f6" strokeWidth="2" fill="none" />
      <text x="12" y="16" textAnchor="middle" fill="#3b82f6" fontSize="12" fontWeight="600" fontFamily="Inter, sans-serif">G</text>
    </svg>
  ),
  huggingface: ({ size, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" fill="none" />
      <circle cx="9" cy="10" r="1.5" fill="#f59e0b" />
      <circle cx="15" cy="10" r="1.5" fill="#f59e0b" />
      <path d="M8 15c1 2 7 2 8 0" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    </svg>
  ),
};

const fallbackLogo = ({ size, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" stroke="#71717a" strokeWidth="2" fill="none" />
    <circle cx="12" cy="12" r="3" fill="#71717a" />
    <line x1="12" y1="2" x2="12" y2="6" stroke="#71717a" strokeWidth="1.5" />
    <line x1="12" y1="18" x2="12" y2="22" stroke="#71717a" strokeWidth="1.5" />
    <line x1="2" y1="12" x2="6" y2="12" stroke="#71717a" strokeWidth="1.5" />
    <line x1="18" y1="12" x2="22" y2="12" stroke="#71717a" strokeWidth="1.5" />
  </svg>
);

function resolveProvider(provider) {
  if (!provider) return null;
  const p = provider.toLowerCase();
  if (p.includes('openai') || p.includes('gpt')) return 'openai';
  if (p.includes('anthropic') || p.includes('claude')) return 'anthropic';
  if (p.includes('deepseek')) return 'deepseek';
  if (p.includes('google') || p.includes('gemini')) return 'google';
  if (p.includes('hugging') || p.includes('hf')) return 'huggingface';
  return null;
}

export function ProviderLogo({ provider, size = 16, className = '' }) {
  const key = resolveProvider(provider);
  const Logo = (key && logos[key]) || fallbackLogo;
  return <Logo size={size} className={className} />;
}

export default ProviderLogo;
